import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
export interface OciModel {
    filePath: string;
}
@Injectable({ providedIn: 'root' })
export class OciService {
    private baseUrl = 'Oci';

    constructor(private apiService: ApiService) { }

    getOciResource(body: OciModel): Observable<any> {
        return this.apiService.postFile(`${this.baseUrl}/GetFile/`, body);
    }

    getOciResourceEnhanced(filePath: string): Observable<Blob> {
        const encodedPath = encodeURIComponent(filePath);
        return this.apiService.getBlob(`${this.baseUrl}/GetFile_Enhance?filePath=${encodedPath}`);
    }

    getOciResourceEnhancedWithoutSpinner(filePath: string): Observable<Blob> {
        const encodedPath = encodeURIComponent(filePath);
        return this.apiService.getBlobWithoutSpinner(`${this.baseUrl}/GetFile_Enhance?filePath=${encodedPath}`);
    }

    addOciResource(data: any): Observable<any> {
        return this.apiService.post(`${this.baseUrl}/AddOciResource`, data);
    }

    deleteOciResource(resourceId: string): Observable<any> {
        return this.apiService.delete(`${this.baseUrl}/DeleteOciResource/${resourceId}`);
    }
}
